export const FAQ_LINK = 'https://docs.safepokt.finance/safepokt/faq'
export const DOCS_LINK = 'https://docs.safepokt.finance'
export const DISCORD_LINK = 'https://dsc.gg/safepokt'
export const TWITTER_LINK = 'https://twitter.com/SafePOKT'
export const GITHUB_LINK = 'https://github.com/SafePokt'
